import * as React from 'react';
import type { SVGProps } from 'react';

const SvgTriangleTop = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={718} height={713} fill="none" {...props}>
    <g
      stroke="#fec6cc"
      style={{
        mixBlendMode: 'multiply',
      }}
    >
      <path strokeWidth={10} d="M673.362 699.942 12.179 38.759h661.183v661.183Z" />
      <path strokeWidth={25} d="M704.578 648.65 69.002 13.074h635.576V648.65Z" />
    </g>
  </svg>
);
export default SvgTriangleTop;
